"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("@qc-modules/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = (0, _styledComponents["default"])("div").withConfig({
  displayName: "table__Wrapper",
  componentId: "sc-143z9pt-0"
})(["clear:both;display:flex;overflow-x:auto;width:100%;"]);
var MinimalTable = (0, _styledComponents["default"])("table").withConfig({
  displayName: "table__MinimalTable",
  componentId: "sc-143z9pt-1"
})(["border-top:2px solid ", ";border-bottom:2px solid ", ";border-collapse:collapse;flex-grow:1;text-align:left;white-space:nowrap;"], function (props) {
  return (0, _styles.colors)("title-black", props);
}, function (props) {
  return (0, _styles.colors)("title-black", props);
});
var HeadRow = (0, _styledComponents["default"])("tr").withConfig({
  displayName: "table__HeadRow",
  componentId: "sc-143z9pt-2"
})(["background-color:", ";"], function (props) {
  return (0, _styles.colors)("grey", props);
});
var HeadCell = (0, _styledComponents["default"])("th").withConfig({
  displayName: "table__HeadCell",
  componentId: "sc-143z9pt-3"
})(["border-left:2px solid ", ";border-right:2px solid ", ";padding:10px;"], function (props) {
  return (0, _styles.colors)("title-black", props);
}, function (props) {
  return (0, _styles.colors)("title-black", props);
});
var HeadCellWrapper = (0, _styledComponents["default"])("div").withConfig({
  displayName: "table__HeadCellWrapper",
  componentId: "sc-143z9pt-4"
})(["align-items:center;display:flex;justify-content:space-between;"]);
var Row = (0, _styledComponents["default"])("tr").withConfig({
  displayName: "table__Row",
  componentId: "sc-143z9pt-5"
})(["&:nth-child(2n){background-color:", ";}"], function (props) {
  return (0, _styles.colors)("grey", props);
});
var Cell = (0, _styledComponents["default"])("td").withConfig({
  displayName: "table__Cell",
  componentId: "sc-143z9pt-6"
})(["border-left:2px solid ", ";border-right:2px solid ", ";padding:10px;"], function (props) {
  return (0, _styles.colors)("title-black", props);
}, function (props) {
  return (0, _styles.colors)("title-black", props);
});
var propTypes = {
  className: _propTypes.string,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string
  })),
  titles: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    title: _propTypes.string
  }))
};

var Table = function Table(_ref) {
  var className = _ref.className,
      titles = _ref.titles,
      data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(MinimalTable, null, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement(HeadRow, null, (0, _ramda.map)(function (_ref2) {
    var title = _ref2.title;
    return /*#__PURE__*/_react["default"].createElement(HeadCell, {
      key: title
    }, /*#__PURE__*/_react["default"].createElement(HeadCellWrapper, null, title));
  }, titles))), /*#__PURE__*/_react["default"].createElement("tbody", null, (0, _ramda.map)(function (datum) {
    return /*#__PURE__*/_react["default"].createElement(Row, {
      key: datum
    }, (0, _ramda.mapObjIndexed)(function (value, key) {
      return /*#__PURE__*/_react["default"].createElement(Cell, {
        key: key
      }, value);
    }, datum));
  }, data))));
};

Table.propTypes = propTypes;
var _default = Table;
exports["default"] = _default;